import ArchivedItemsView from './ArchivedItemsView'

export default ArchivedItemsView
